import { render, staticRenderFns } from "./addDeptDialog.vue?vue&type=template&id=5ddc918e&"
import script from "./addDeptDialog.vue?vue&type=script&lang=js&"
export * from "./addDeptDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports